export default __webpack_public_path__ + "static/media/cdn77.e6ba8c17.svg";